import type { CounselorYouth } from '@appTypes/esb';
import type {
  BalanceSelectorValues,
  CounseledYouthRecipient,
} from '@modules/messaging/types';
import { personTagType } from '@shared';

export function transformYouthsToRecipients(
  youths: CounselorYouth[],
): CounseledYouthRecipient[] {
  if (!Array.isArray(youths)) return [];

  return youths.map((youth): CounseledYouthRecipient => {
    // Build parent relations matching the Recipient type definition
    const relationships: CounseledYouthRecipient[] = [];
    if (youth.parentMemberId) {
      relationships.push({
        firstName: youth.parentFirstName,
        lastName: youth.parentLastName,
        hasEmail: youth.hasParentGuardianEmail,
        noEmails: false,
        active: true,
        memberId: youth.parentMemberId,
        inactiveReason: youth.hasParentGuardianEmail ? 'ACTIVE' : 'NO_EMAIL',
        gender: '',
        tags: [personTagType.PARENT_GUARDIAN],
        filters: [],
        relationships: [],
        memberIdsToAdd: [],
        memberIdsToRemove: [],
        meritBadgesCounseling: new Set([]),
      });
    }

    let youthInactiveReason = 'ACTIVE';

    if (!youth.hasParentGuardianEmail) {
      youthInactiveReason = 'NO_ACTIVE_GUARDIAN';
    } else if (!youth.hasEmail) {
      youthInactiveReason = 'NO_EMAIL';
    }

    return {
      firstName: youth.firstName,
      lastName: youth.lastName,
      personGuid: youth.personGuid,
      memberId: youth.memberId,
      active: true,
      inactiveReason: youthInactiveReason,
      gender: youth.gender,
      hasEmail: youth.hasEmail,
      noEmails: false,
      tags: [personTagType.YOUTH],
      filters: ['youth'],
      relationships: relationships,
      memberIdsToAdd: [youth.parentMemberId],
      memberIdsToRemove: [youth.parentMemberId],
      meritBadgesCounseling: new Set(
        youth.meritBadgesCounseling.map(mb => mb.meritBadgeId),
      ),
    };
  });
}

export const defaultBalanceFilters: BalanceSelectorValues = {
  operation: 'equal',
  balanceType: 'positive',
  amount: 0,
};
